import { RouteLink, RouteList } from "Routes";

// simple redirects - static URL mappings
export const Redirects: Map<string, string> = new Map([
    ["/aate", "https://docs.google.com/forms/d/e/1FAIpQLSclNPUFoMLBEG8NECqKS1fMVunpD0aKkZ69ZfPVczEzaKOWVg/viewform"],
    ["/about", RouteList.Pricing],
    [
        "/comp-entry",
        "https://docs.google.com/forms/d/e/1FAIpQLSfoId0y3JXtp6rbCAOlRdKKUomFa8sjyJmbv25ZG1XVtjC-xw/viewform?usp=sf_link",
    ],
    ["/discover/hall-of-fame", RouteList.HallOfFame],
    ["/enter-code", RouteList.MyGamesJoinGame],
    ["/games", RouteList.MyGames],
    ["/games/enter-code", RouteList.MyGamesJoinGame],
    ["/games/hall-of-fame", RouteList.HallOfFame],
    ["/games/history", RouteList.MyGamesPastPlayer],
    ["/games/homework", RouteList.MyGamesHomework],
    ["/games/host", RouteList.MyGamesActiveHost],
    ["/games/moderate", RouteList.MyGamesActiveHost],
    ["/games/my-games", RouteList.MyGamesActivePlayer],
    ["/games/new-game", RouteList.MyGamesNewGame],
    ["/games/play", RouteList.MyGamesJoinGame],
    ["/games/reports", RouteList.MyGamesPastHost],
    ["/games/showcase", RouteList.MyGamesPastPlayer],
    ["/games/templates", RouteList.MyGamesMyPrompts],
    ["/games/yearbooks", RouteList.Yearbook],
    ["/help", RouteList.Videos],
    ["/help/about-us", RouteList.Team],
    ["/help/contact-us", RouteList.Contact],
    ["/help/events", RouteList.Events],
    ["/help/faqs", RouteList.Faqs],
    ["/help/newsletter", RouteList.Newsletter],
    ["/help/permissions", RouteList.Privacy],
    ["/help/privacy", RouteList.Privacy],
    ["/help/resources", RouteList.Resources],
    ["/help/safety", RouteList.Privacy],
    ["/help/terms", RouteList.Terms],
    ["/help/tips", RouteList.Home],
    ["/help/videos", RouteList.Videos],
    ["/my-frankenstories", RouteList.MyGamesActivePlayer],
    ["/permissions", RouteList.Privacy],
    ["/profile/my-school", RouteList.ProfileSchool],
    ["/profile/my-subscriptions", RouteList.ProfileSubscription],
    ["/profile/refer-a-friend", RouteList.ProfileReferralCode],
    ["/profile/referral-code", RouteList.ProfileReferralCode],
    ["/prompts", RouteList.Discover],
    ["/prompts/browse", RouteList.Discover],
    ["/register", RouteList.Signup],
    ["/safety", RouteList.Privacy],
    ["/subscriptions", RouteList.Pricing],
    ["/subscriptions/about", RouteList.Pricing],
    ["/subscriptions/purchase", RouteList.Pricing],
    ["/subscriptions/refer-a-friend", RouteList.ReferAFriend],
    ["/yearbooks", RouteList.Yearbook],
]);

// parameterized redirects - routes with parameters that need transformation
export interface ParameterizedRedirect {
    sourcePattern: RegExp;
    targetFunction: (params: Array<string>) => string;
}

export const ParameterizedRedirects: Array<ParameterizedRedirect> = [
    // /story/:code -> /hall-of-fame/game/:code
    {
        sourcePattern: /^\/story\/([A-Za-z0-9]{6})$/i,
        targetFunction: params => RouteLink.hallOfFameGame(params[0] ?? ""),
    },

    // /games/completed-games/:code -> /my-games/past/player/:code
    {
        sourcePattern: /^\/games\/completed-games\/([A-Za-z0-9]{6})$/i,
        targetFunction: params => RouteLink.myGamesPastPlayerGame(params[0] ?? ""),
    },

    // /games/hall-of-fame/:code -> /hall-of-fame/game/:code
    {
        sourcePattern: /^\/games\/hall-of-fame\/([A-Za-z0-9]{6})$/i,
        targetFunction: params => RouteLink.hallOfFameGame(params[0] ?? ""),
    },

    // /games/history/:code -> /my-games/past/player/:code
    {
        sourcePattern: /^\/games\/history\/([A-Za-z0-9]{6})$/i,
        targetFunction: params => RouteLink.myGamesPastPlayerGame(params[0] ?? ""),
    },

    // /games/host/:code -> /my-games/host/:code
    {
        sourcePattern: /^\/games\/host\/([A-Za-z0-9]{6})$/i,
        targetFunction: params => RouteLink.myGamesHostGame(params[0] ?? ""),
    },

    // /games/join/:code -> /my-games/enter/:code
    {
        sourcePattern: /^\/games\/join\/([A-Za-z0-9]{6})$/i,
        targetFunction: params => RouteLink.myGamesEnter(params[0] ?? ""),
    },

    // /games/moderate/:code -> /my-games/host/:code
    {
        sourcePattern: /^\/games\/moderate\/([A-Za-z0-9]{6})$/i,
        targetFunction: params => RouteLink.myGamesHostGame(params[0] ?? ""),
    },

    // /games/reports/:code -> /my-games/past/host/:code
    {
        sourcePattern: /^\/games\/reports\/([A-Za-z0-9]{6})$/i,
        targetFunction: params => RouteLink.myGamesPastHostGame(params[0] ?? ""),
    },

    // /games/settings/:code -> /my-games/host/:code/settings
    {
        sourcePattern: /^\/games\/settings\/([A-Za-z0-9]{6})$/i,
        targetFunction: params => RouteLink.myGamesHostGameSettings(params[0] ?? ""),
    },

    // /games/spectate/:code -> /my-games/spectate/:code
    {
        sourcePattern: /^\/games\/spectate\/([A-Za-z0-9]{6})$/i,
        targetFunction: params => RouteLink.myGamesSpectate(params[0] ?? ""),
    },

    // /games/templates/:id -> /my-games/my-prompts/:id
    {
        sourcePattern: /^\/games\/templates\/([0-9]+)$/i,
        targetFunction: params => RouteLink.myGamesPrompt(params[0] ?? ""),
    },

    // /games/templates/:id/assign-to-class -> /my-games/my-prompts/:id/assign-to-class
    {
        sourcePattern: /^\/games\/templates\/([0-9]+)\/assign-to-class$/i,
        targetFunction: params => RouteLink.myGamesPromptAssignToClass(Number(params[0] ?? "0")),
    },

    // /games/templates/:id/assign-to-individuals -> /my-games/my-prompts/:id/assign-as-homework
    {
        sourcePattern: /^\/games\/templates\/([0-9]+)\/assign-to-individuals$/i,
        targetFunction: params => RouteLink.myGamesPromptAssignAsHomework(Number(params[0] ?? "0")),
    },

    // /games/templates/:id/edit -> /my-games/my-prompts/:id/edit
    {
        sourcePattern: /^\/games\/templates\/([0-9]+)\/edit$/i,
        targetFunction: params => RouteLink.myGamesPromptEdit(Number(params[0] ?? "0")),
    },

    // this one must be towards the end
    // /games/:code => /my-games/game/:code
    {
        sourcePattern: /^\/games\/([A-Za-z0-9]{6})$/i,
        targetFunction: params => RouteLink.myGamesGame(params[0] ?? ""),
    },

    // /discover/hall-of-fame/:code -> /hall-of-fame/game/:code
    {
        sourcePattern: /^\/discover\/hall-of-fame\/([A-Za-z0-9]{6})$/i,
        targetFunction: params => RouteLink.hallOfFameGame(params[0] ?? ""),
    },

    // Note: discoverSet requires (id: number, name: string) but we only have friendlyUrl
    // These would need to be handled differently or the RouteLink function needs to be updated
    // For now, creating simple redirects to discover page
    {
        sourcePattern: /^\/prompts\/browse\/([^/]+)$/i,
        targetFunction: params => `/discover?search=${encodeURIComponent(params[0] ?? "")}`,
    },

    {
        sourcePattern: /^\/prompts\/browse\/([^/]+)\/([^/]+)$/i,
        targetFunction: params => `/discover?search=${encodeURIComponent(params[1] ?? "")}`,
    },
];
